module.exports = __webpack_public_path__ + "img/VOUCHER.68f43e5f.svg";